// ----------------------------------------------------------------------------
// Component: Video Block
// ----------------------------------------------------------------------------
//
// Content component that positions a video in a custom-sized block, or in
// the flex-position or flex-grid.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/video-player/video-block';
import 'snippets/_containers/modal/modal';

// Styles
import './_video-block.scss';
